import { Alert } from "../../../../core/Alert.js";
import type { AccountNoticesContent } from "../../accountContent.js";

/**
 * Standing conditions over every tab (a locked account), quiet on load, and the last action that
 * failed, announced as it appears. A title leads on its own line.
 */
export function AccountNotices({ notices }: AccountNoticesContent) {
  if (notices.length === 0) return null;
  return (
    <div className="flex flex-col gap-3">
      {notices.map((notice) => (
        <Alert
          key={notice.id}
          tone={notice.tone}
          title={notice.title}
          announce={notice.announce ?? true}
        >
          {notice.text}
        </Alert>
      ))}
    </div>
  );
}
